// index.ts
import RoundIcon from '@/assets/brush-icons/round.svg?raw'
import SquareIcon from '@/assets/brush-icons/square.svg?raw'
import DashedIcon from '@/assets/brush-icons/dashed.svg?raw'
import PointedIcon from '@/assets/brush-icons/pointed.svg?raw'
import BowTieIcon from '@/assets/brush-icons/bow-tie.svg?raw'
import ThickToThinIcon from '@/assets/brush-icons/thick-to-thin.svg?raw'
import ThinToThickIcon from '@/assets/brush-icons/thin-to-thick.svg?raw'
import SprayIcon from '@/assets/brush-icons/spray.svg?raw'

export const brushIcons = {
  round: RoundIcon,
  square: SquareIcon,
  dashed: DashedIcon,
  pointed: PointedIcon,
  'bow-tie': BowTieIcon,
  'thick-to-thin': ThickToThinIcon,
  'thin-to-thick': ThinToThickIcon,
  spray: SprayIcon
} as const

export type BrushIconKey = keyof typeof brushIcons

export const getBrushIcon = (brushType: string): string => {
  const svgContent = brushIcons[brushType as BrushIconKey] || brushIcons.round
  return `data:image/svg+xml;base64,${btoa(svgContent)}`
}

export const getBrushIconRaw = (brushType: string): string => {
  return brushIcons[brushType as BrushIconKey] || brushIcons.round
}

export {
  RoundIcon,
  SquareIcon,
  DashedIcon,
  PointedIcon,
  BowTieIcon,
  ThickToThinIcon,
  ThinToThickIcon,
  SprayIcon
}